export default __webpack_public_path__ + "static/media/crown_racing.b6d4cf95.png";